function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { setStyle, setObject, getNewObject, getTransformX, getTransformY, roundToTwo, minmax, isFunction } from './../shared/utils';
import { NAME, CLASS_CONTAINER, CLASS_ZOOMER_DISABLE } from './../shared/constants';
export default {
  /**
   * get container (element) data
   * @returns {Object}
   */
  getContainerData: function getContainerData() {
    return getNewObject(this.data.containerData);
  },
  /**
   * get image data
   * @returns {Object}
   */
  getImageData: function getImageData() {
    return getNewObject(this.data.imageData);
  },
  /**
   * get slider value
   * @returns {Number}
   */
  getSliderValue: function getSliderValue() {
    var _this$__modules__$sli;
    return (_this$__modules__$sli = this.__modules__.slider) === null || _this$__modules__$sli === void 0 ? void 0 : _this$__modules__$sli.value;
  },
  /**
   * get now zoom ratio
   * @returns {Number}
   */
  getZoomRatio: function getZoomRatio() {
    return this.ratio;
  },
  /**
   * zoom
   * zoomRatio - zoomin when pass a positive number, zoomout when pass a negative number
   * pointer - a object which return from getPoiner()
   * @param {Number, Object} 
   */
  zoom: function zoom(zoomRatio, pointer) {
    var image = this.image,
      data = this.data,
      options = this.options,
      ratio = this.ratio;
    var bounds = options.bounds,
      maxRatio = options.maxRatio;
    if (bounds && ratio === 1 && zoomRatio < 0) return;
    if (maxRatio && ratio === maxRatio && zoomRatio > 0) return;
    var originImageData = data.originImageData;
    var containerData = this.getContainerData();
    var imageData = this.getImageData();
    var imageRect = image.getBoundingClientRect();
    var calcRatio = roundToTwo(ratio * (zoomRatio + 1));
    var newRatio = bounds && calcRatio < 1 ? 1 : maxRatio && calcRatio > maxRatio ? maxRatio : calcRatio;
    var newZoomRatio = newRatio / ratio - 1;
    var newWidth = originImageData.width * newRatio;
    var newHeight = originImageData.height * newRatio;
    var newLeft = (containerData.width - newWidth) / 2;
    var newTop = (containerData.height - newHeight) / 2;
    var distanceX = pointer ? (imageData.width / 2 - pointer.clientX + imageRect.left) * newZoomRatio + getTransformX(image) : getTransformX(image);
    var distanceY = pointer ? (imageData.height / 2 - pointer.clientY + imageRect.top) * newZoomRatio + getTransformY(image) : getTransformY(image);
    var transformX = bounds ? minmax(distanceX, newLeft, -newLeft) : distanceX;
    var transformY = bounds ? minmax(distanceY, newTop, -newTop) : distanceY;
    var newData = {
      width: newWidth,
      height: newHeight,
      left: newLeft,
      top: newTop
    };
    setObject(data.imageData, newData);
    setStyle(image, _objectSpread(_objectSpread({}, newData), {}, {
      transform: "translate(".concat(transformX, "px, ").concat(transformY, "px)")
    }));
    this.ratio = newRatio;
    this.emit('zoom', newRatio);

    // if has slider
    if (options.slider) {
      var slider = this.__modules__.slider;
      var ratioPercentage = roundToTwo(1 - (slider.maxRatio - newRatio) / (slider.maxRatio - 1)) * 100;
      slider.value = minmax(ratioPercentage, 0, 100);
      this.slideTo(ratioPercentage, true);
    }

    // if zoomer disableOnBounds
    if (options.zoomer) {
      var zoomer = this.__modules__.zoomer;
      if (zoomer.disableOnBounds) {
        var _bounds = options.bounds;
        var _this$__modules__$zoo = this.__modules__.zoomer,
          zoomerInEl = _this$__modules__$zoo.zoomerInEl,
          zoomerOutEl = _this$__modules__$zoo.zoomerOutEl;
        _bounds && this.ratio === 1 ? zoomerOutEl.classList.add(CLASS_ZOOMER_DISABLE) : zoomerOutEl.classList.remove(CLASS_ZOOMER_DISABLE);
        this.ratio === maxRatio ? zoomerInEl.classList.add(CLASS_ZOOMER_DISABLE) : zoomerInEl.classList.remove(CLASS_ZOOMER_DISABLE);
      }
    }
    return this;
  },
  /**
   * zoomTo (zoom to a specific ratio)
   * zoomRatio - zoomin when pass a number more than 1, zoomout when pass a number less than 1
   * @param {Number} 
   */
  zoomTo: function zoomTo(zoomRatio) {
    var ratio = this.ratio;
    if (zoomRatio !== ratio) {
      var calcRatio = zoomRatio / ratio - 1;
      this.zoom(calcRatio);
    }
    return this;
  },
  /**
   * move - move to a relative position
   * x - number
   * y - number
   * @param {Number}
   */
  move: function move() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var image = this.image,
      data = this.data,
      options = this.options;
    var imageData = data.imageData,
      dragData = data.dragData;
    var top = imageData.top,
      left = imageData.left;
    var transX = dragData.transX,
      transY = dragData.transY;
    var bounds = options.bounds;
    var calcTransX = bounds ? minmax(transX - x, left, -left) : transX - x;
    var calcTransY = bounds ? minmax(transY - y, top, -top) : transY - y;
    var newTransX = roundToTwo(calcTransX);
    var newTransY = roundToTwo(calcTransY);
    setObject(dragData, {
      transX: newTransX,
      transY: newTransY
    });
    image.style.transform = "translate(".concat(newTransX, "px, ").concat(newTransY, "px)");
    return this;
  },
  /**
   * moveTo - move to a absolute position
   * x - number
   * y - number
   * @param {Number}
   */
  moveTo: function moveTo(x, y) {
    var _x, _y;
    var data = this.data,
      options = this.options;
    var imageData = data.imageData,
      dragData = data.dragData;
    var top = imageData.top,
      left = imageData.left;
    var transX = dragData.transX,
      transY = dragData.transY;
    var bounds = options.bounds;
    x = (_x = x) !== null && _x !== void 0 ? _x : Math.abs(left);
    y = (_y = y) !== null && _y !== void 0 ? _y : Math.abs(top);
    var calcTransX = bounds ? minmax(left + x + transX, left, -left) : left + x + transX;
    var calcTransY = bounds ? minmax(top + y + transY, top, -top) : top + y + transY;
    this.move(calcTransX, calcTransY);
    return this;
  },
  /**
   * slideTo (only work on the slider)
   * value - a numer between 0-100
   * @param {Number}
   */
  slideTo: function slideTo(value, onlySlide) {
    var __modules__ = this.__modules__;
    if (!__modules__.slider) return;
    var slider = __modules__.slider;
    var position = slider.direction === 'horizontal' ? 'left' : 'top';
    var symbol = slider.direction === 'horizontal' ? '' : '-';
    var distance = minmax(value, 0, 100);
    slider.sliderButton.style[position] = "".concat(symbol).concat(distance, "%");
    if (!onlySlide) {
      var percentage = distance / 100;
      var minRatio = this.ratio < 1 ? this.ratio : 1;
      var maxRatio = this.ratio > slider.maxRatio ? this.ratio : slider.maxRatio;
      var ratio = (maxRatio - minRatio) * percentage + minRatio;
      this.zoomTo(ratio);
    }
    return this;
  },
  /**
   * reset image to initial status
   */
  reset: function reset() {
    var image = this.image;
    this.zoomTo(1);
    setStyle(image, {
      transform: 'translate(0, 0)'
    });
    this.emit('reset');
    return this;
  },
  /**
   * destory the instance of zoomist
   */
  destroy: function destroy() {
    var element = this.element,
      wrapper = this.wrapper;
    var _this$__modules__ = this.__modules__,
      slider = _this$__modules__.slider,
      zoomer = _this$__modules__.zoomer;
    element[NAME] = undefined;
    this.mounted = false;
    if (slider) this.destroySlider();
    if (zoomer) this.destroyZoomer();
    wrapper.remove();
    element.style.removeProperty('width');
    element.style.removeProperty('padding-bottom');
    element.classList.remove(CLASS_CONTAINER);
    this.emit('destroy');
    return this;
  },
  /**
   * a syntactic sugar of destroy and init
   */
  update: function update() {
    this.destroy().init();
    this.emit('update');
    return this;
  },
  /**
   * add handler on __events__
   * @param {String} events 
   * @param {Function} handler 
   */
  on: function on(events, handler) {
    if (!isFunction(handler)) return this;
    var __events__ = this.__events__;
    events.split(' ').forEach(function (evt) {
      if (!__events__[evt]) __events__[evt] = [];
      __events__[evt].push(handler);
    });
    return this;
  },
  /**
   * invoke handlers in __events__[event]
   * @param  {String, ...} args 
   */
  emit: function emit() {
    var _this = this;
    var __events__ = this.__events__;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var event = args[0];
    var data = args.slice(1, args.length);
    if (!__events__[event]) return this;
    __events__[event].forEach(function (handler) {
      if (isFunction(handler)) handler.apply(_this, data);
    });
    return this;
  }
};